import { List } from './list';

const virtualStore = new List();
const classicStore = new List();

export * from './list';
export { virtualStore, classicStore };
